import React, { useEffect, createElement } from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { ComingSoon } from './components/ComingSoon';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/g6ebYu1Xjz1ZLZcTiKmQS5/background-removed.png';
export function App() {
  useEffect(() => {
    document.title = 'AFEXA';
    const head = document.head;
    const rels = ['icon', 'shortcut icon', 'apple-touch-icon'];
    rels.forEach(rel => {
      let link = head.querySelector('link[rel="' + rel + '"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', rel);
        head.appendChild(link);
      }
      link.setAttribute('href', LOGO_URL);
    });
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Nav data-id="element-1" />
      <Hero data-id="element-2" />
      <ComingSoon data-id="element-3" />
      <ContactForm data-id="element-4" />
      <Footer data-id="element-5" />
    </div>;
}